var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.logoClass,style:(_vm.inlineStyle),attrs:{"src":_vm.logoUrl,"alt":_vm.logoAlt}})
}
var staticRenderFns = []

export { render, staticRenderFns }